import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ImpersonateButton from "./ImpersonateButton";
import ServerError from "../common/ServerError";
import { ProductUtilities } from "@p1s/p1s-common-react/utilities";

import { getVirtualProductById } from "../../actions/ProductActions";
import { accessSite } from "../../actions/ImpersonateActions";
import { getAvailableApplications } from "../../actions/UrlActions";
import { getLinkedSites } from "../../actions/UsersActions";
import UrlHelper from "../../utilities/UrlHelper";

export class SiteSelectorContainer extends Component {
    constructor(props) {
        super(props);

        var virtualProductId = UrlHelper.getVirtualProductFromUrl();

        this.state = {
            virtualProductId: virtualProductId,
            selectedSite: 0
        };

        this._handleChangeSite = this._handleChangeSite.bind(this);
    }

    componentDidMount() {
        import("./_styles.scss");
        var virtualProductId = UrlHelper.getVirtualProductFromUrl();

        this.props.getVirtualProductById(virtualProductId);
        this.props.getLinkedSites(virtualProductId);
    }

    render() {
        const productsUrl = UrlHelper.getProductSelectorUrl();
        const productConfiguration = ProductUtilities.getProductConfigurationById(this.state.virtualProductId);

        if (this.props.virtualProduct == null)
            return null;

        if (this.props.redirectTo != null) {
            window.location = this.props.redirectTo;
        }

        const serverError = this.props.serverError;
        const hasServerError = serverError && serverError.length > 0;

        return (
            <div id="content">
                <div className="account-page-title col-xs-12">
                    <span>Locations</span>
                </div>
                <div className="account-page-subtitle col-xs-12">
                    <span>Select a {this.props.virtualProduct.virtualProductName} location to access.</span>
                </div>
                <div className="account-form col-xs-12">
                    <div className="account-form-title">
                        <span className={productConfiguration.iconClass}>{productConfiguration.iconName}</span>
                        <span>{this.props.virtualProduct.virtualProductName}</span>
                    </div>
                    <div className="wk-field-item">
                        <div className="wk-select-field">
                            <select id="selectSite" value={this.state.selectedSite} onChange={this._handleChangeSite}>
                                <option key="0" value="0">Select Location</option>
                                {
                                    this.props.linkedSites.map((site) => <option key={site.value} value={site.value}>{site.label}</option>)
                                }
                            </select>
                        </div>
                        <div className="wk-field-error" />
                    </div>
                    <div className="wk-button-bar">
                        <ImpersonateButton onClick={() => this._handleImpersonate()}
                            isValid={this.state.selectedSite && this.state.selectedSite != 0} />
                    </div>
                    <ServerError
                        errorSummary={"Login Failed"}
                        serverError={serverError}
                        isVisible={hasServerError}/>
                </div>
                <div className="account-navigation col-xs-12">
                    <span className="ion ion-arrow-left-c"/>
                    <a id="backToProducts" href={productsUrl}>Back to Products</a>
                </div>
                <div className="account-navigation col-xs-12">
                    <a id="logout" onClick={this._onSignOut}>Sign Out</a>
                </div>
            </div>
        );
    }

    _onSignOut() {
        window.location = UrlHelper.getLogoutUrl();
    }

    _handleImpersonate() {
        const returnUrl = UrlHelper.parseUrl().query.returnUrl;
        const productName = this.props.virtualProduct.productName;
        this.props.accessSite(this.state.selectedSite, productName, returnUrl);
    }

    _handleChangeSite (event) {
        const value = event.target.value ? event.target.value : nul;
        this.setState({ selectedSite: value });
    }
}

SiteSelectorContainer.propTypes = {
    getLinkedSites: PropTypes.func,
    getVirtualProductById: PropTypes.func,
    serverError: PropTypes.string
};

const mapStateToProps = state => ({
    linkedSites: state.productState.linkedSites,
    virtualProduct: state.productState.virtualProduct,
    redirectTo: state.appState.redirectTo,
    serverError: state.impersonateState.errorMessage
});

const mapDispatchToProps = (dispatch) => {
    return ({
        getAvailableApplications: ()=> dispatch(getAvailableApplications()),
        getLinkedSites: (productId) => dispatch(getLinkedSites(productId)),
        getVirtualProductById: (productId) => dispatch(getVirtualProductById(productId)),
        accessSite: (userId, productId, returnUrl) => dispatch(accessSite(userId, productId, returnUrl))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteSelectorContainer);
